import { ReplaceAndRedirect } from '@sorare/routing';

const ClubsRedirect = () => {
  return <ReplaceAndRedirect from="/clubs/" to="/teams/" />;
};
export default ClubsRedirect;
